// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  animation: fadeIn 0.5s ease-in-out;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.settings-card {
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 200px;
}

.card-primary {
  background-color: #f2f7ff;
}
.card-secondary {
  background-color: #fef3f2;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.card-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #374151;
}
.card-secondary .card-title {
  color: #f97316;
}

.card-icon-wrapper {
  text-align: right;
}
.card-icon {
  width: 48px;
  height: 48px;
}

.kebab-menu-container {
  position: relative;
}
.kebab-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  font-size: 24px;
  line-height: 1;
  font-weight: bold;
  color: #6b7280;
}
.kebab-btn img {
  width: 20px;
  height: 20px;
}

.kebab-dropdown {
  position: absolute;
  right: 0;
  top: 100%;
  background-color: white;
  border: 1px solid #f3f4f6;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 8px;
  width: max-content;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.kebab-dropdown a {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  color: #374151;
  text-decoration: none;
}
.kebab-dropdown a:hover {
  background-color: #f9fafb;
}

/* Add these new styles at the end of your CSS file */

.page-main-title {
  font-size: 28px;
  font-weight: 600;
  color: #174078;
  margin-bottom: 24px;
}

/* Styles for our new live data card */
.settings-card.card-live-data {
  background-color: #f0f9ff; /* A light blue to distinguish it */
  position: relative;
}

.settings-card .card-content {
  margin-top: auto; /* Pushes content to the bottom */
}

.loading-text,
.error-text {
  font-size: 16px;
  color: #6b7280;
  font-weight: 500;
}

.error-text {
  color: #ef4444;
}

.live-data-value {
  font-size: 48px;
  font-weight: 700;
  color: #1e3a8a; /* Navo Navy */
  margin: 0;
  line-height: 1;
}

.update-link {
  background: none;
  border: none;
  color: #f97316; /* Navo Orange */
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 0;
  margin-top: 8px;
}

.update-link:hover {
  text-decoration: underline;
}

.card-live-data .card-icon-wrapper {
  position: absolute;
  top: 24px;
  right: 24px;
  opacity: 0.1;
}

.card-live-data .card-icon {
  width: 64px;
  height: 64px;
}

@media (max-width: 992px) {
  .settings-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .settings-grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .settings-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .settings-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .settings-card {
    padding: 12px;
    min-height: 120px;
  }
  .page-main-title {
    font-size: 20px;
  }
}

.settings-section {
  margin-bottom: 32px;
}

.settings-section-title {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  margin: 0 0 12px;
}

.settings-grid-single {
  grid-template-columns: minmax(0, 360px);
}

.settings-link-row {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 480px;
  padding: 16px 20px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.settings-link-row:hover {
  border-color: #fdba74;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.settings-link-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #fff4ec;
  color: #f97316;
  font-size: 20px;
}

.settings-link-text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.settings-link-label {
  font-size: 16px;
  font-weight: 600;
  color: #174078;
}

.settings-link-hint {
  font-size: 13px;
  color: #6b7280;
}

.settings-link-chevron {
  color: #9ca3af;
  font-size: 20px;
}

/* Each settings section owns a card within the responsive page grid. */
.settings-layout { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px; align-items: start; }
.settings-layout > .integration-panel, .settings-layout > .settings-section { min-width: 0; margin-bottom: 0; }
.settings-layout > .settings-section { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 24px; }
.settings-layout .settings-grid-single { grid-template-columns: minmax(0, 1fr); }
.settings-layout .settings-link-row { max-width: none; }
.settings-layout .integration-form { max-width: none; }
@media (max-width: 1000px) { .settings-layout { grid-template-columns: minmax(0, 1fr); } }
@media (max-width: 600px) { .settings-layout { gap: 16px; } .settings-layout > .settings-section { padding: 16px; } }
`, "",{"version":3,"sources":["webpack://./src/pages/SettingsPage/SettingsPage.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA,qDAAqD;;AAErD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc,EAAE,gBAAgB;EAChC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uEAAuE;AACvE,mBAAmB,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACnH,8EAA8E,YAAY,EAAE,gBAAgB,EAAE;AAC9G,uCAAuC,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,aAAa,EAAE;AACxH,yCAAyC,qCAAqC,EAAE;AAChF,sCAAsC,eAAe,EAAE;AACvD,qCAAqC,eAAe,EAAE;AACtD,6BAA6B,mBAAmB,qCAAqC,EAAE,EAAE;AACzF,4BAA4B,mBAAmB,SAAS,EAAE,EAAE,uCAAuC,aAAa,EAAE,EAAE","sourcesContent":[".settings-page {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.settings-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n.settings-card {\n  border-radius: 12px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 200px;\n}\n\n.card-primary {\n  background-color: #f2f7ff;\n}\n.card-secondary {\n  background-color: #fef3f2;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.card-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #374151;\n}\n.card-secondary .card-title {\n  color: #f97316;\n}\n\n.card-icon-wrapper {\n  text-align: right;\n}\n.card-icon {\n  width: 48px;\n  height: 48px;\n}\n\n.kebab-menu-container {\n  position: relative;\n}\n.kebab-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  font-size: 24px;\n  line-height: 1;\n  font-weight: bold;\n  color: #6b7280;\n}\n.kebab-btn img {\n  width: 20px;\n  height: 20px;\n}\n\n.kebab-dropdown {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  background-color: white;\n  border: 1px solid #f3f4f6;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  padding: 8px;\n  width: max-content;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.kebab-dropdown a {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #374151;\n  text-decoration: none;\n}\n.kebab-dropdown a:hover {\n  background-color: #f9fafb;\n}\n\n/* Add these new styles at the end of your CSS file */\n\n.page-main-title {\n  font-size: 28px;\n  font-weight: 600;\n  color: #174078;\n  margin-bottom: 24px;\n}\n\n/* Styles for our new live data card */\n.settings-card.card-live-data {\n  background-color: #f0f9ff; /* A light blue to distinguish it */\n  position: relative;\n}\n\n.settings-card .card-content {\n  margin-top: auto; /* Pushes content to the bottom */\n}\n\n.loading-text,\n.error-text {\n  font-size: 16px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.error-text {\n  color: #ef4444;\n}\n\n.live-data-value {\n  font-size: 48px;\n  font-weight: 700;\n  color: #1e3a8a; /* Navo Navy */\n  margin: 0;\n  line-height: 1;\n}\n\n.update-link {\n  background: none;\n  border: none;\n  color: #f97316; /* Navo Orange */\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 4px 0;\n  margin-top: 8px;\n}\n\n.update-link:hover {\n  text-decoration: underline;\n}\n\n.card-live-data .card-icon-wrapper {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  opacity: 0.1;\n}\n\n.card-live-data .card-icon {\n  width: 64px;\n  height: 64px;\n}\n\n@media (max-width: 992px) {\n  .settings-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .settings-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media (max-width: 768px) {\n  .settings-grid {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 600px) {\n  .settings-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  .settings-card {\n    padding: 12px;\n    min-height: 120px;\n  }\n  .page-main-title {\n    font-size: 20px;\n  }\n}\n\n.settings-section {\n  margin-bottom: 32px;\n}\n\n.settings-section-title {\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n  margin: 0 0 12px;\n}\n\n.settings-grid-single {\n  grid-template-columns: minmax(0, 360px);\n}\n\n.settings-link-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  max-width: 480px;\n  padding: 16px 20px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.settings-link-row:hover {\n  border-color: #fdba74;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.settings-link-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: #fff4ec;\n  color: #f97316;\n  font-size: 20px;\n}\n\n.settings-link-text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.settings-link-label {\n  font-size: 16px;\n  font-weight: 600;\n  color: #174078;\n}\n\n.settings-link-hint {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.settings-link-chevron {\n  color: #9ca3af;\n  font-size: 20px;\n}\n\n/* Each settings section owns a card within the responsive page grid. */\n.settings-layout { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px; align-items: start; }\n.settings-layout > .integration-panel, .settings-layout > .settings-section { min-width: 0; margin-bottom: 0; }\n.settings-layout > .settings-section { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 24px; }\n.settings-layout .settings-grid-single { grid-template-columns: minmax(0, 1fr); }\n.settings-layout .settings-link-row { max-width: none; }\n.settings-layout .integration-form { max-width: none; }\n@media (max-width: 1000px) { .settings-layout { grid-template-columns: minmax(0, 1fr); } }\n@media (max-width: 600px) { .settings-layout { gap: 16px; } .settings-layout > .settings-section { padding: 16px; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
